import { render, staticRenderFns } from "./IconColorPicker.vue?vue&type=template&id=542c6e1b&scoped=true&"
import script from "./IconColorPicker.vue?vue&type=script&lang=js&"
export * from "./IconColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./IconColorPicker.vue?vue&type=style&index=0&id=542c6e1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c6e1b",
  null
  
)

export default component.exports